/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallComponentFunction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m6.533 13 1.537 1.281-3.467 3.359L8.07 21l-1.537 1.281L2 17.64zm5.933 0L17 17.64l-4.534 4.641L10.93 21l3.466-3.36-3.466-3.359zM11 6a6.997 6.997 0 0 1 6.996 6.76L18 13h-2a4.997 4.997 0 0 0-4.783-4.995L11 8zm0-4a10.995 10.995 0 0 1 10.996 10.711L22 13h-2a8.995 8.995 0 0 0-8.734-8.996L11 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCallComponentFunction as CallComponentFunction };
